import React, { useLayoutEffect } from "react";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import Headline from "../../Headline/Headline";

import Card from "../../UI/Card/Card";
import BillingView from "./BillingView";
import BillingHistory from "./BillingHistory";
import InvoicesAddress from "./InvoicesAddress";
import InvoicesOptions from "./InvoicesOptions";
//import InvoicesMetrics from "./InvoicesMetrics";
import InvoicesStatistics from "./InvoicesStatistics";
import Invoices from "./Invoices";

import * as Utils from "../../Utils/BillingUtils";

import BillingUpdate from "./BillingUpdate";
import LogService from "../../../middleware/CommonSdk/LogService";

const LOG_TAG = "BILLING";

const Billing = (props) => {
    LogService.info(LOG_TAG, "Enter");

    const intl = useIntl();
    const title = intl.messages.billingTitle;
    const subtitle = intl.messages.billingMessage;   

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    /* Display card to create a new payment method*/
    function CreatePaymentMethod() {
        if (!props.hasPaymentMethod) {
            return (
                <div className="row">
                    <div className="d-flex col-xs-12 col-md-12 col-xl-12">
                        <Card title={intl.messages.billingRegisterTitle} subtitle={intl.messages.billingRegisterSubTitle}>
                            <BillingUpdate />
                        </Card>
                    </div>
                </div>

            )
        } else { return null }
    }

    /* Display cards to manage payments method */
    function DisplayPaymentMethod() {
        if (props.hasPaymentMethod) {
            return (
                <div className="row">
                    <div className="d-flex col-xm-12 col-md-12 col-lg-5">
                        <BillingView />
                    </div>
                    <div className="d-flex col-xm-12 col-md-12 col-lg-7">
                        <BillingHistory />
                    </div>
                </div>
            )
        } else { return null }
    }

    /* Display cards to manage invoices (download, metrics...) */
    function DisplayInvoices() {
        if (props.hasAnAccount) {
            return (
                <div className="row">
                    {/* <div className="d-flex col-xm-12 col-md-12 col-lg-4">
                        <InvoicesMetrics />
                    </div> */}
                    <div className="d-flex col-xm-12 col-md-12 col-lg-6">
                        <Invoices />
                    </div>
                    <div className="d-flex col-xm-12 col-md-12 col-lg-6">
                        <InvoicesStatistics />
                    </div>
                </div>
            )
        } else { return null }
    }

    /* Display cards to manage account zuora */
    function DisplayAccount() {
        if (props.hasAnAccount) {
            return (
                <div className="row">
                    <div className="d-flex col-xm-12 col-md-12 col-lg-6">
                        <InvoicesAddress />
                    </div>
                    <div className="d-flex col-xm-12 col-md-12 col-lg-6">
                        <InvoicesOptions />
                    </div>
                </div>
            )
        } else { return null }
    }

    /* ================================================================= */
    return (
        <div>
            <Headline
                title={title}
                subtitle={subtitle}
            />

            <DisplayPaymentMethod />
            <DisplayInvoices />
            <DisplayAccount />
            <CreatePaymentMethod />
        </div>
    );
    
}

const mapStateToProps = state => {
    return {
        hasPaymentMethod: Utils.hasPaymentMethod(state.payments),
        hasAnAccount: Utils.hasInvoicesAccount(state.invoices)
    };
};

export default connect(mapStateToProps)(Billing);